import logo from 'assets/logo.svg';
import { Link } from 'react-router-dom';

export const Logo = () => {
  return (
    <Link className="flex items-center" to="/">
      <img className="h-20 w-auto" src={logo} alt="Workflow" />
    </Link>
  );
};
